import { MaybeRefOrGetter, toValue } from 'vue';
import { Router } from 'vue-router';

import { useRouteChange } from '@/composables/navigation/useRouteChange';
import { sendProductsSearched } from '@/utils/analytics/productSearched';

export function useSearch(router?: Router) {
  const { navigateTo } = useRouteChange(router);

  async function handleSearch(query: MaybeRefOrGetter<string | undefined>, sendEvent = true) {
    const value = toValue(query);
    let href = '/search/instant';
    if (value) {
      if (sendEvent) sendProductsSearched({ query: value, pageSection: 'Main Search Bar' });
      href += `?query=${value}`;
    }
    await navigateTo(href);
  }

  return { handleSearch };
}
